﻿import { useEffect } from 'react'
import { useAuthStore } from '../../auth/hooks/useAuthStore'
import { registerFcmWebPushDeviceToken, subscribeToForegroundMessages } from '../services/fcmPushService'

export function useFcmPushNotification() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const user = useAuthStore((state) => state.user)

  useEffect(() => {
    if (!isAuthenticated) return

    let isMounted = true
    let unsubscribeForeground: (() => void) | null = null

    registerFcmWebPushDeviceToken(user?.id).then((token) => {
      if (token && isMounted) {
        subscribeToForegroundMessages((payload) => {
          console.log('[FCM] Foreground notification received:', payload)
        }).then((unsub) => {
          unsubscribeForeground = unsub
        })
      }
    })

    return () => {
      isMounted = false
      if (unsubscribeForeground) {
        unsubscribeForeground()
      }
    }
  }, [isAuthenticated, user?.id])
}
